
 



 
 import {fs} from "Config/FsConfig";
 
    import ACLTemplateSearchParameter from 'Modules/Core/Scripts/AppServiceContract/ACLTemplateSearchParameter';

    import ACLTemplateCategoryData from 'Modules/Core/Scripts/ACLTemplateCategoryData';

    import ACLTemplateUpdateParameter from 'Modules/Core/Scripts/ACLTemplateUpdateParameter';

    import ResourceData from 'Modules/Core/Scripts/ResourceData';

    import ModuleData from 'Modules/Core/Scripts/AppServiceContract/ModuleData';


    //module ACLTemplateAppService {
    class ACLTemplateAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Core.AppService/ACLTemplateAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Core.AppService/ACLTemplateAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFindTemplate = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ACLTemplateAppService/FindTemplate`;
    public RouteFindTemplate() : string {
        return this.ControllerUrl + "/"+"FindTemplate";
    }
    public FindTemplate(parameter: ACLTemplateSearchParameter): JQuery.jqXHR<ACLTemplateCategoryData[]> {
        return $.ajax({
                url: this.RouteFindTemplate(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteSaveTemplate = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ACLTemplateAppService/SaveTemplate`;
    public RouteSaveTemplate() : string {
        return this.ControllerUrl + "/"+"SaveTemplate";
    }
    public SaveTemplate(parameter: ACLTemplateUpdateParameter): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteSaveTemplate(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?applicationCode=${encodeURIComponent(applicationCode)}
    //public static RouteLoadResource = (applicationCode: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ACLTemplateAppService/LoadResource`;
    public RouteLoadResource(applicationCode: string) : string {
        return this.ControllerUrl + "/"+"LoadResource";
    }
    public LoadResource(applicationCode: string): JQuery.jqXHR<ResourceData[]> {
        return $.ajax({
                url: this.RouteLoadResource(applicationCode),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(applicationCode),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteLoadModuleList = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ACLTemplateAppService/LoadModuleList`;
    public RouteLoadModuleList() : string {
        return this.ControllerUrl + "/"+"LoadModuleList";
    }
    public LoadModuleList(): JQuery.jqXHR<ModuleData[]> {
        return $.ajax({
                url: this.RouteLoadModuleList(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default ACLTemplateAppService;



